{
  "0b20d6c68a3c4706": "Actualizaciones de visitas",
  "25181e0f807f4bbc": "No se pierda los recordatorios para verificar visitas pendientes.",
  "2ac741e6203af759": "Quizás más tarde",
  "2b194934439e9665": "Reservas de turnos",
  "3fea642185ba9acd": "Mantente al día",
  "4165e2978c2117ef": "Mensajes de chat",
  "682be64ae7801fd0": "Habilitar notificaciones",
  "894dcbb521a1269c": "Recordatorios de verificación",
  "8a4dd392e661b037": "Cambios en el horario",
  "bb665d949734749a": "Esta notificación ha expirado",
  "be3df4f3d324f259": "Conoce en el instante en que un turno es reclamado o cancelado.",
  "bf28ed42be7d72ef": "Conoce el momento en que se reclama o se cancela un turno.",
  "cdd5d0719a0e47f5": "Activa las notificaciones push para recibir actualizaciones a tiempo, incluso cuando la aplicación esté cerrada.",
  "d5936d76aa451f83": "Sepa cuándo se confirma una visita, se registra o un profesional queda sin asignar.",
  "d735e44ede615db9": "Mantente informado sobre actualizaciones de última hora en tu calendario.",
  "dc78a7975e25749f": "Responde a los profesionales sin necesidad de mantener una pestaña abierta."
}
